import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export default function CdadHeaderFilterTab({setCurrentTab}: any) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setCurrentTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <Tabs value={value} onChange={handleChange} sx={{ border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: "8px", width: "max-content" }}>
        <Tab sx={{textTransform :"none", fontWeight: "600", fontSize: "16px"}} label="Signals*" />
        <Tab sx={{textTransform :"none", fontWeight: "600", fontSize: "16px"}} label="Vehicle" />
        <Tab sx={{textTransform :"none", fontWeight: "600", fontSize: "16px"}} label="Campaign" />
        <Tab sx={{textTransform :"none", fontWeight: "600", fontSize: "16px"}} label="Warranty & Claims" />
        <Tab sx={{textTransform :"none", fontWeight: "600", fontSize: "16px"}} label="Sampling" />
      </Tabs>
    </Box>
  );
}